import { createApi } from "element-plus-admin/utils/create-api";
import { useAuth } from "@/composables/use-auth";

export const schoolsApi = createApi({
  url: "/admin/schools",
  headers: useAuth().getHeaders,
});
